// extracted by mini-css-extract-plugin
export var borderRadius = "_8o-4";
export var large = "_8o-3";
export var logoContainer = "_8o-0";
export var nameLogo = "_8o-2";
export var small = "_8o-1";